import React, { useState } from 'react';
import styles from './Form.module.css';
import { useTranslation } from 'react-i18next';

import { Button, PasswordInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import useAuth from '@hooks/useAuth/useAuth';
import { useNavigate, useParams } from 'react-router-dom';

import {
  mainPasswordValidater,
  passwordValidator
} from '@utils/validators';

const Form = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [, { updatePassword }] = useAuth()
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      password: '',
      passwordConformation: ''
    },

    validate: {
      password: (value) => mainPasswordValidater(value, t),
      passwordConformation: (value, { password }) => passwordValidator(value, { password }, t),
    },
  });

  const handleSuccesss = () => {
    navigate('/password_changed')
  }

  const handleSubmit = (values) => {
    updatePassword(id, values, handleSuccesss)
  }

  return (
    <div className={styles.wrapper}>
      <form
        className={styles.form}
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <PasswordInput
          password
          label={t('password.label')}
          key={form.key('password')}
          placeholder={t('password.placeholder')}
          {...form.getInputProps('password')}
        />

        <div className={styles.separator} />

        <PasswordInput
          password
          label={t('password.again.label')}
          key={form.key('passwordConformation')}
          placeholder={t('password.placeholder')}
          {...form.getInputProps('passwordConformation')}
        />

        <Button
          className={styles.button}
          fullWidth
          type="submit"
        >
          {t('save')}
        </Button>
      </form>
    </div >
  )
}

export default Form;
